import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';

class WarehouseService {
    constructor(apiUrl) {
        this.getReturnRequests = async ({ orderId, terminalCode, discoveryService, platformId, }) => {
            const { data } = await this.warehouseApi.get(`/return-requests`, {
                params: {
                    orderIds: orderId,
                    sortLatest: true,
                    platformId,
                },
            });
            const res = data === null || data === void 0 ? void 0 : data.request;
            const allItemSkus = (res === null || res === void 0 ? void 0 : res.reduce((skus, req) => {
                skus.push(...req.items.map((item) => item.sku));
                return skus;
            }, [])) || [];
            if (allItemSkus.length > 0) {
                const products = await discoveryService.getProductDetailBySkus({
                    skus: Array.from(new Set(allItemSkus)),
                    terminalCode,
                });
                return res.map((req) => {
                    return Object.assign(Object.assign({}, req), { items: req.items.map((item) => {
                            var _a;
                            const product = products.find((product) => product.productInfo.sku === item.sku);
                            return Object.assign(Object.assign({}, item), { imageUrl: ((_a = product === null || product === void 0 ? void 0 : product.productInfo) === null || _a === void 0 ? void 0 : _a.imageUrl) || '' });
                        }) });
                });
            }
            return res;
        };
        this.getReturnReasons = async (platformId) => {
            const { data } = await this.warehouseApi.get(`/return-reasons`, {
                params: {
                    platformId: platformId,
                    status: 'RETURN_REASON_STATUS_ACTIVE',
                    limit: 200,
                },
            });
            return (data === null || data === void 0 ? void 0 : data.reasons) || [];
        };
        this.addReturnRequest = async (orderId, requestPayload) => {
            const payload = Object.assign({ orderId: orderId }, requestPayload);
            return await this.warehouseApi.post(`/return-request`, {
                data: payload,
            });
        };
        this.warehouseApi = new Api(apiUrl);
        this.warehouseApi.addInterceptor(accessTokenInterceptor);
    }
}

export { WarehouseService };
